import * as XLSX from "xlsx";

const SHEET_NAME_MAX_LENGTH = 31;
const NAME_CHARS_EXCEL_FORBIDS = /[:\\/?*[\]]/g;

const toSafeName = (name) => String(name ?? "").replace(NAME_CHARS_EXCEL_FORBIDS, "-").trim();

export const downloadWorkbook = ({ columns, rows, sheetName, fileName }) => {
  const worksheet = XLSX.utils.aoa_to_sheet([
    columns.map((column) => column.label),
    ...rows.map((row) =>
      columns.map((column) => {
        const value = row[column.key];
        return value === null || value === undefined ? "" : value;
      })
    ),
  ]);

  const workbook = XLSX.utils.book_new();
  const safeSheetName = toSafeName(sheetName).slice(0, SHEET_NAME_MAX_LENGTH).trim();
  XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName || "Sheet1");
  XLSX.writeFile(workbook, `${toSafeName(fileName) || "report"}.xlsx`);
};
